// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3vlBk","log":"ModalInventoryLogs_log__17K4i","date":"ModalInventoryLogs_date__1dA1G","userName":"ModalInventoryLogs_userName__3m8A1"};